











import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import ProxyTypingAction from '../../../logic/Proxy/actions/ProxyTypingAction'

@Component
export default class TypingSample extends Vue{
  @Prop() action!: ProxyTypingAction

  @Prop() i18n!: i18n
}
